




























































import { Component, Vue, Watch, Mixins, Provide, Prop } from 'vue-property-decorator';
import { setProject } from '@/apis/tokenData';
import { mounted } from '@/services/VueTimmer';
import { db } from '@/firebase';
import { groupBy, keyBy, mapValues } from 'lodash';
import SearchMixins from '@/mixins/searchMixins';
import { SyncWithRouterQuerySimple } from '@/services/SyncWithRoute';
import { Debounce } from 'lodash-decorators';

@Component
export default class PricingTabel extends Mixins(SearchMixins) {
  rows = ['binance','binance_v3','bittrex','bitfinex', 'kryptono', 'exonium'];

  subs: Record<string, any> = {};

  @Prop({default:""})
  filter!: string

  @Provide()
  price: Record<string, Record<string, { price; lastUpdate }>> = {};

  @SyncWithRouterQuerySimple('search')
  searchText: string;

  get search():string{
    return this.filter || this.searchText
  }

  @mounted
  getAllReferenExchange() {}

  @mounted
  @Watch('rows')
  onRowChanges() {
    for (let i of this.rows) {
      if (this.subs[i] === undefined) {
        if (this.price[i] === undefined)
          Vue.set(this.price, i, {});
        this.subs[i] = db
          .collection('pricing_server')
          .doc(i)
          .collection('pairs')
          .onSnapshot(snapshot => {
            for (var doc of snapshot.docChanges()) {
              if (doc.type == 'added' || doc.type == 'modified') {
                let data = doc.doc.data();
                if(parseFloat(data.price) > 0){
                  let oldData = this.price[i][doc.doc.id] 
                  Vue.set(this.price[i], doc.doc.id, {
                    ...data,
                    timestamp : Date.now(),
                    change: (oldData && oldData.price) 
                      ? (data.price > oldData.price ? 'up' : (data.price <  oldData.price ? '' : 'down'))
                      : ""
                  });
                }
              }
            }
          });
      }
    }
  }

  beforeDestroy(){
    for(let i in this.subs){
      try {
        this.subs[i]()
      } catch (error) {}
    }
  }

  get allPairs() : Record<string,{pair,pricing,timestamp}[]> {
    return mapValues(
      this.price,
      values => Object
        .entries(values)
        .map(([pair,value]) => (<any>{pair,...value}))
    )
  }

  get allFilteredPairs() : Record<string,{pair,pricing,timestamp}[]>{
    return mapValues(
      this.allPairs,
      (values, key) => this.filterSearch(
        values,
        e => `${key} ${e.pair}`
      )
    ) 
  }


  get allMarket():string[]{
    return Object
      .entries(groupBy(
        [].concat(...Object.values(this.allPairs)), 
        e => e.pair.split('_')[1]
      ))
      .filter(e => e[1].length)
      .sortBy(e => -e[1].length)
      .map(e => e[0])
  }

  get pairWithAllMarkets() {
    return  mapValues(
      this.allFilteredPairs,
      values => Object
        .entries(groupBy(
          values, 
          e => e.pair.split('_')[0]
        ))
        .map(([coinName,pairDatas]) => ([
          coinName,
          pairDatas.toObjectBy((e:any) => e.pair.split("_")[1])
        ]))
    ) 
    return 
  }
}
